//this is ES6 syntax, it's essentially equivalent to: var React = require('react')
import React from 'react';
import { reduxForm, Field, FieldArray} from 'redux-form' // imported Field

//Controls
import Controls from "utils/renderControl.js";

//Validation function
import validate from "./validate";

import renderEmploymentHistory from "./renderEmploymentHistory";

class EmploymentHistory extends React.Component{

	constructor(props) {
		super(props);
	}

	//now this component is getting passed props from the AppContainer
	static propTypes = {
		config: React.PropTypes.object,
		location: React.PropTypes.object,
		onSubmit: React.PropTypes.func,
		goToPrevious: React.PropTypes.func
	};

	componentDidMount(){
		setTimeout(function(){
			if(this.props.location.query.validate){
				const submitter = this.props.handleSubmit(this.props.onSubmit)
				submitter() // submits
			}
		}.bind(this), 100)
	}

	render(){
		const { handleSubmit, pristine, reset, submitting,config } = this.props;

		return (
			<form id="employment-history" onSubmit={handleSubmit}>
				<h2>Employment History</h2>
				{/************************
					* MOBILE - PREVIOUS/NEXT
					*************************/}
				<div className="actions-mobile clearfix visible-xs-block">
					<a disabled={submitting} className="prev" onClick={this.props.goToPrevious}><i className="fa fa-chevron-left" aria-hidden="true"></i> Previous</a>
					<button type="submit" disabled={submitting} className="btn">
						Next <i className="fa fa-chevron-right" aria-hidden="true"></i>
					</button>
				</div>

				{/************************
					* EMPLOYMENT HISTORY
					*************************/}
				<FieldArray name="employmentHistory" component={renderEmploymentHistory.bind(null, config)}/>

				{/************************
					* PREVIOUS/NEXT
					*************************/}
				<div className="actions">
					<button type="button" disabled={submitting} className="btn btn-default" onClick={this.props.goToPrevious}>
						Previous
					</button>
					<button type="submit" disabled={submitting} className="btn btn-primary">
						Next
					</button>
				</div>
			</form>
		);
	}
}

export default reduxForm({
	form:"employment-application",
	destroyOnUnmount: false,
	validate
})(EmploymentHistory)
